<template>
    <div class="py-1">
    <ValidationProvider :name="name" :rules="rules" v-slot="{ errors, valid }">
      <vs-input
        :danger="rules && !valid && !!errors[0]"
        :danger-text="errors[0]"
        :type="type"
        :min="min"
        @input="$emit('input', $event)"
        @focus="$emit('focus', $event)"
        @click="$emit('click', $event)"
        class="w-full"
        novalidate
        v-bind="$attrs"
        v-model="innerValue"
      />
    </ValidationProvider>
  </div>
</template>

<script>
  export default {
    props: ['value', 'name', 'label', 'placeholder', 'disabled', 'inline', 'box', 'type', 'min', 'rules'],
    data: () => ({
      innerValue: ""
    }),
    watch: {
      // Handles internal model changes.
      // innerValue (newVal) {
      //   this.$emit("input", newVal);
      // },
      // Handles external model changes.
      value (newVal) {
        this.innerValue = newVal;
      }
    },
    created () {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  }
</script>

<style scoped>

</style>
